<template>
    <!-- 飘窗效果 -->
    <div id="thediv" ref="thediv" style="position: absolute; z-index: 2000; left: 0; top: 0" v-show="thedivShow" @mouseover="clearFdAd" @mouseout="starFdAd">
        <!-- <div
      style="
        cursor: pointer;
        text-align: right;
        font-size: 12px;
        color: #999999;
      "
      @click="thedivShow = false"
    >
      关闭  
    </div> -->
        <a @click="toNewDetail" target="_blank"><img :src="list.image" border="0" /></a>
    </div>
</template>

<script>
import { getDict } from "../api/dict";
import { getNewsList } from "../api/news.js";
var interval;
export default {
    data() {
        return {
            xPos: 0,
            yPos: 0,
            xin: true,
            yin: true,
            step: 1,
            delay: 18,
            height: 0,
            Hoffset: 0,
            Woffset: 0,
            yon: 0,
            xon: 0,
            pause: true,
            thedivShow: true,

            searchParams: {
                page: 1,
                pageSize: 1,
                status: "2",
                dictId: "",
                dictName: "",
            },

            list: null,
        };
    },

    mounted() {
        interval = setInterval(this.changePos, this.delay);
    },

    created() {
        this.getDict();
    },

    destroyed() {
        clearInterval(interval);
    },

    methods: {
        toNewDetail() {
            switch (this.list.type) {
                case "1": {
                    window.open(this.list.url);
                    break;
                }
                case "2": {
                    let routeUrl = this.$router.resolve({
                        path: "/index/NewsDetail",
                        query: {
                            activeName: this.list.dictName,
                            id: this.list.id,
                        },
                    });
                    window.open(routeUrl.href, "_blank");
                    break;
                }
                case "3": {
                    window.open(this.list.fileUrl);
                    break;
                }
            }
        },

        getDict() {
            let params = {
                parentId: "16",
            };
            getDict(params).then((res) => {
                if (res.code == 200) {
                    let typeList = res.data;
                    this.searchParams.dictId = typeList[0].id;
                    this.searchParams.dictName = typeList[0].dictName;
                    this.getNewsList();
                }
            });
        },

        getNewsList() {
            getNewsList(this.searchParams).then((res) => {
                if (res.code == 200) {
                    this.list = res.data.records[0];
                }
            });
        },

        changePos() {
            let width = document.documentElement.clientWidth;
            let height = document.documentElement.clientHeight;
            this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
            this.Woffset = this.$refs.thediv.offsetWidth;

            // 滚动部分跟随屏幕滚动
            // this.$refs.thediv.style.left = (this.xPos + document.body.scrollLeft + document.documentElement.scrollLeft) + "px";
            // this.$refs.thediv.style.top = (this.yPos + document.body.scrollTop + document.documentElement.scrollTop) + "px";

            // 滚动部分不随屏幕滚动
            this.$refs.thediv.style.left =
                this.xPos + document.body.scrollLeft + "px";
            this.$refs.thediv.style.top =
                this.yPos + document.body.scrollTop + "px";

            if (this.yon) {
                this.yPos = this.yPos + this.step;
            } else {
                this.yPos = this.yPos - this.step;
            }
            if (this.yPos < 0) {
                this.yon = 1;
                this.yPos = 0;
            }
            if (this.yPos >= height - this.Hoffset) {
                this.yon = 0;
                this.yPos = height - this.Hoffset;
            }

            if (this.xon) {
                this.xPos = this.xPos + this.step;
            } else {
                this.xPos = this.xPos - this.step;
            }
            if (this.xPos < 0) {
                this.xon = 1;
                this.xPos = 0;
            }
            if (this.xPos >= width - this.Woffset) {
                this.xon = 0;
                this.xPos = width - this.Woffset;
            }
        },
        clearFdAd() {
            clearInterval(interval);
        },
        starFdAd() {
            interval = setInterval(this.changePos, this.delay);
        },
    },
};
</script>

<style scoped>
#thediv {
    z-index: 2000;
    position: fixed;
    top: 43px;
    left: 2px;
    height: 184px;
    width: 280px;
    overflow: hidden;
}
#thediv img {
    width: 260px;
    height: 146px;
}
</style>




// WEBPACK FOOTER //
// src/components/Baywindow.vue